import type { RootState } from '../store'
import type { HashtagGroup } from './types'

export const selectHashtagGroups = (state: RootState): HashtagGroup[] =>
  state.hashtagGroups.groups

export const selectHashtagGroupName = (state: RootState): string =>
  state.hashtagGroups.name

export const selectHashtagGroupText = (state: RootState): string =>
  state.hashtagGroups.text
